import NEW_BOOKING_STEPS from 'constants/newBookingSteps';

const PRIVATE_PACKAGE = Object.freeze({
    ownerPetDetails: NEW_BOOKING_STEPS.ownerPetDetails,
    bundle: NEW_BOOKING_STEPS.bundle,
    productList: NEW_BOOKING_STEPS.productList,
    confirmation: NEW_BOOKING_STEPS.confirmation
});

export default PRIVATE_PACKAGE;
